module.exports = __webpack_public_path__ + "img/ry_17.6e784897.png";